import { useState } from "react";
import { Box, Grid, Stack, Typography } from "@mui/material";
import i18n from "../../i18n-config";
import SigninTextInput from "../../components/SigninTextInput";
import { capitalizeFirstLetter } from "../../utils/strings";
import { CustomButton, CustomDropdown, CustomLoader } from "../../components";
import theme from "../../theme/theme";
import { useNavigate } from "react-router-dom";
import { createAsyncTransaction, Transaction } from "../../store/features/transactionSlice";
import {
  ROLES,
  TRANSACTION_MONEY_OPERATION,
  TRANSACTION_STATUT,
  TRANSACTION_TYPE,
  TYPE_OPERATION,
  TYPE_SERVICE,
} from "../../utils/constants";
import notifyMessage from "../../utils/notify";
import { useDispatch } from "react-redux";

function TransactionForm() {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState<Transaction>({
    description: "",
    valeur: 0,
    moyenOperation: "",
    statutTransaction: "",
    typeSolde: "",
    typeService: null,
    emetteur: null,
    destinataire: null,
    numeroTransaction: "",
    typeOperation: null,
  });

  const onChangeField = (key: string, value: string | number) => {
    setFormData({
      ...formData,
      [key]: value,
    });
  };

  const goBack = () => {
    navigate("/transactions");
  };

  const dispatch = useDispatch();

  const toggleLoader = () => {
    setLoading(!loading);
  };

  const callback = () => {
    setLoading(false);
    goBack();
    notifyMessage({
      message: capitalizeFirstLetter(i18n.t("create_success")),
      severity: "success",
    });
  };

  const onError = () => {
    setLoading(false);
    notifyMessage({
      message: capitalizeFirstLetter(i18n.t("error_occured")),
      severity: "error",
    });
  };

  const onSubmit = () => {
    toggleLoader();
    dispatch(createAsyncTransaction(formData, callback, onError) as any);
    // if (!item) {
    // } else {
    //   dispatch(
    //     updateAsyncAdminUtilisateur(
    //       { ...item, ...formData },
    //       callback,
    //       onError
    //     ) as any
    //   );
    // }
  };

  const disabled = false;
  // const disabled = !formData.typeSolde?.trim();

  return (
    <Box sx={{ height: "100vh", backgroundColor: "#F9F9F9" }} p={3} pt={6}>
      <Stack direction={"row"} justifyContent="space-between" mb={3}>
        <Typography fontSize={22} fontWeight="600">
          {i18n.t("ajouter_transaction")}
        </Typography>
      </Stack>

      <Box
        sx={{
          p: 3,
          backgroundColor: "white",
          boxShadow: "0px 4px 4px rgba(139, 139, 139, 0.05)",
        }}
      >
        <Grid container spacing={3}>
          <Grid item xs={4}>
            <SigninTextInput
              title={capitalizeFirstLetter(i18n.t("date"))}
              value={formData.dateCreation}
              type="date"
              onChange={(value: string) => onChangeField("dateCreation", value)}
            />
            <CustomDropdown
              title={i18n.t("statut")}
              value={formData.statutTransaction}
              items={TRANSACTION_STATUT}
              handleChange={(value: string) => onChangeField("statutTransaction", value)}
            />
            <CustomDropdown
              title={i18n.t("mode_paiement")}
              value={formData.moyenOperation}
              items={TRANSACTION_MONEY_OPERATION}
              handleChange={(value: string) =>
                onChangeField("moyenOperation", value)
              }
            />
            <CustomDropdown
              title={i18n.t("createur_transaction")}
              value={formData.role}
              items={ROLES}
              handleChange={(value: string) => onChangeField("role", value)}
            />
          </Grid>
          <Grid item xs={4}>
            <SigninTextInput
              title={capitalizeFirstLetter(i18n.t("montant"))}
              value={formData.valeur?.toString()}
              onChange={(value: string) => onChangeField("valeur", Number(value))}
            />
            <CustomDropdown
              title={i18n.t("emetteur")}
              value={formData.emetteur}
              items={ROLES}
              handleChange={(value: string) => onChangeField("emetteur", value)}
            />
            <SigninTextInput
              title={capitalizeFirstLetter(i18n.t("numero_transaction"))}
              value={formData.numeroTransaction}
              onChange={(value: string) =>
                onChangeField("numeroTransaction", value)
              }
            />
            <CustomDropdown
              title={i18n.t("type_operation")}
              value={formData.typeOperation}
              items={TYPE_OPERATION}
              handleChange={(value: string) =>
                onChangeField("typeOperation", value)
              }
            />
          </Grid>
          <Grid item xs={4}>
            <CustomDropdown
              title={i18n.t("type_solde")}
              value={formData.typeSolde}
              items={TRANSACTION_TYPE}
              handleChange={(value: string) =>
                onChangeField("typeSolde", value)
              }
            />
            <CustomDropdown
              title={i18n.t("type_service")}
              value={formData.typeService}
              items={TYPE_SERVICE}
              handleChange={(value: string) =>
                onChangeField("typeService", value)
              }
            />
            <SigninTextInput
              title={capitalizeFirstLetter(i18n.t("nom_prenom_emetteur"))}
              value={formData.name}
              onChange={(value: string) => onChangeField("name", value)}
            />
            <SigninTextInput
              title={capitalizeFirstLetter(i18n.t("description"))}
              value={formData.description}
              onChange={(value: string) => onChangeField("description", value)}
            />
          </Grid>
        </Grid>
      </Box>

      <Stack direction={"row"} mt={5} justifyContent="space-between">
        <CustomButton
          title={capitalizeFirstLetter(i18n.t("cancel"))}
          rootStyle={{
            width: "250px",
            borderRadius: "6px",
            height: "42px",
            backgroundColor: "#EDEDED",
          }}
          titleStyle={{ color: theme.colors.black }}
          onClick={goBack}
        />
        <CustomButton
          title={capitalizeFirstLetter(i18n.t("enregistrer"))}
          onClick={onSubmit}
          disabled={disabled}
          rootStyle={{
            width: "250px",
            borderRadius: "6px",
            height: "42px",
            backgroundColor: disabled
              ? theme.colors.disabled
              : theme.colors.primary,
          }}
          titleStyle={{ color: theme.colors.white }}
        />
      </Stack>
      <CustomLoader open={loading} handleClose={toggleLoader} />
    </Box>
  );
}

export default TransactionForm;
